import React, { useEffect } from "react";
import {
  bodyMeasurements,
  hipToCrotch,
  measurementFormulas,
} from "../../shopData";
import "./SizeChartModal.css";

export default function SizeChartModal({ onClose, highlightSize }) {
  useEffect(() => {
    function handleKeyDown(e) {
      if (e.key === "Escape") onClose();
    }
    document.addEventListener("keydown", handleKeyDown);
    document.body.style.overflow = "hidden";
    return () => {
      document.removeEventListener("keydown", handleKeyDown);
      document.body.style.overflow = "auto";
    };
  }, [onClose]);

  return (
    <div className="size-chart-overlay" onClick={onClose}>
      <div className="size-chart-modal" onClick={(e) => e.stopPropagation()}>
        <button
          className="modal-close-btn"
          onClick={onClose}
          aria-label="Close"
        >
          &times;
        </button>

        <h2>Size Chart</h2>
        <p className="size-chart-subtitle">
          All measurements are in inches. If you're between two sizes, we
          recommend sizing up.
        </p>

        <div className="size-chart-table-wrapper">
          <table className="size-chart-table">
            <thead>
              <tr>
                <th>Size</th>
                <th>Shoulder Width</th>
                <th>Neck Width</th>
                <th>Bust</th>
                <th>Waist</th>
                <th>Hips</th>
                <th>Shoulder–Bust Point</th>
                <th>Shoulder–Underbust</th>
                <th>Shoulder–Waist (half length)</th>
                <th>Armhole Length</th>
                <th>Armhole</th>
              </tr>
            </thead>
            <tbody>
              {bodyMeasurements.map((row) => (
                <tr
                  key={row.size}
                  className={
                    highlightSize &&
                    (highlightSize === row.label || highlightSize === row.size)
                      ? "highlighted-row"
                      : ""
                  }
                >
                  <td className="size-cell">
                    {row.size} ({row.label})
                  </td>
                  <td>{row.shoulderWidth}"</td>
                  <td>{row.neckWidth}"</td>
                  <td>{row.bust}"</td>
                  <td>{row.waist}"</td>
                  <td>{row.hips}"</td>
                  <td>{row.shoulderToBustPoint}"</td>
                  <td>{row.shoulderToUnderbust}"</td>
                  <td>{row.shoulderToWaist}"</td>
                  <td>{row.armholeLength ? `${row.armholeLength}"` : "—"}</td>
                  <td>{row.armhole}"</td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>

        <h3 className="size-chart-section-title">Hip to Crotch Length</h3>
        <div className="size-chart-table-wrapper size-chart-table-wrapper--narrow">
          <table className="size-chart-table">
            <thead>
              <tr>
                <th>Hip Size</th>
                <th>Crotch Length</th>
              </tr>
            </thead>
            <tbody>
              {hipToCrotch.map((row, idx) => (
                <tr key={idx}>
                  <td>{row.hip}"</td>
                  <td>{row.crotch}"</td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>

        <h3 className="size-chart-section-title">How These Are Calculated</h3>
        <ul className="size-chart-formula-list">
          {measurementFormulas.map((f) => (
            <li key={f.label}>
              <strong>{f.label}</strong> = {f.formula}
            </li>
          ))}
        </ul>
      </div>
    </div>
  );
}
